export const MAX_EMAIL_LENGTH = 100
export const MAX_NAME_LENGTH = 50

export const CVR_LENGTH = 8 // DK CVR: 8 digits
export const EAN_LENGTH = 13 // Standard EAN length
